import type { ReactNode } from 'react';
import { Drawer } from 'antd';
import { I } from '../yeni-design/icons';
import { useDarEkran } from './useDarEkran';

interface RaporCekmecesiProps {
  acik: boolean;
  baslik: string;
  /** Başlığın altındaki tek satır (kod, temsilci, vade). */
  altBaslik?: string;
  onKapat: () => void;
  children?: ReactNode;
  testid?: string;
}

/**
 * S334: satır detayı SAĞDAN açılan çekmecede (sayfa değişmez). Esc ve dışına tıklama kapatır,
 * kapanınca odak açan satıra döner (antd `Drawer` / rc-drawer davranışı).
 *
 * Masaüstü ve tablet: gövde dikey flex, içine konan `RaporTablosu` kalan yüksekliği doldurur ve kendi
 * içinde kayar.
 * TELEFON (<= 767 px): pencere TAM EKRAN ve TEK kaydırma (Yerlice belge detayı, `dashboard.css` S300):
 * başlık üstte, gövde kayar, kart kipindeki toplam şeridi altta yapışık. Kapat düğmesi 44 px.
 */
export function RaporCekmecesi({ acik, baslik, altBaslik, onKapat, children, testid = 'rapor-cekmecesi' }: RaporCekmecesiProps) {
  const telefon = useDarEkran();
  return (
    <Drawer
      open={acik}
      onClose={onKapat}
      placement={telefon ? 'bottom' : 'right'}
      width="min(940px, 94vw)"
      height="100dvh"
      closable={false}
      destroyOnHidden
      title={
        <div className="min-w-0 font-sans" data-testid={`${testid}-baslik`}>
          <h2 className="m-0 text-[16px] font-semibold leading-snug text-ink-900 truncate">{baslik}</h2>
          {altBaslik && <div className="text-[13px] font-normal text-ink-500 truncate">{altBaslik}</div>}
        </div>
      }
      extra={
        <button
          type="button"
          onClick={onKapat}
          aria-label="Kapat"
          className={`focus-ring inline-flex items-center justify-center rounded-md border border-border-strong bg-surface text-ink-700 hover:bg-ink-50 ${telefon ? 'w-11 h-11' : 'w-8 h-8'}`}
        >
          <I.X size={telefon ? 18 : 16} />
        </button>
      }
      styles={{
        header: telefon
          ? { padding: 'calc(6px + env(safe-area-inset-top, 0px)) 8px 6px 16px' }
          : { padding: '12px 16px' },
        body: { padding: 0, display: 'flex', flexDirection: 'column', minHeight: 0, background: '#f8fafc' },
      }}
    >
      {/* `font-sans`: antd Drawer kendi yazı tipini basar; içerik panelin yazısıyla kalsın.
          Telefonda sarmalayıcı kısalmaz (`flex-none` + en az tam boy): kayan, antd'nin gövdesidir. */}
      <div data-testid={testid} className={`flex flex-col font-sans ${telefon ? 'flex-none min-h-full' : 'flex-1 min-h-0'}`}>
        {children}
      </div>
    </Drawer>
  );
}
